module.exports = __webpack_public_path__ + "static/img/ks_axgp.49f1408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ks_axgp.png
// module id = 4SqP
// module chunks = 130